<template>
    <div class="buyNowModalWrapper">
        <div class="buyNowModalOverlay"></div>
        <div class="buyNow-wrapper">
            <div class="pr-2 text-right buyNow-close-btn">
              <span style="pr-4">
                <svg @click="closeBuyNow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g>
                        <path fill="none" d="M0 0h24v24H0z" transform="translate(-1 1) translate(1 -1)"/>
                        <path fill="rgba(0,0,0,0.5)" stroke="rgba(255,255,255,0.6)" d="M12 2a10 10 0 1 0 10 10A9.991 9.991 0 0 0 12 2z" transform="translate(-1 1) translate(1 -1)"/>
                        <path fill="#fff" d="M16.237 8L13 11.238 9.762 8 8 9.762 11.238 13 8 16.237 9.762 18 13 14.763 16.237 18 18 16.237 14.763 13 18 9.762z" transform="translate(-1 1) translate(0 -2)"/>
                    </g>
                </svg>
              </span>
            </div>
            <div class="buyNow-wrapper-total">
              <div class="delivery-estimate" v-if="buyNowAddresses.length">
                  <div class="row justify-content-center pt-3 pb-3">
                      <span class="header-text">{{deliveryEstimateMsg}}</span>
                  </div>
              </div>
              <div class="no-addr-wrap" v-if="!buyNowAddresses.length">
                  <div class="row pt-3 justify-content-center pb-3">
                    <div class="col text-center pt-2">
                      <svg @click="addNewAddress" xmlns="http://www.w3.org/2000/svg" style="height: 40px;width: 145px">
                        <g>
                          <g fill="#fafcfc" stroke="#148c8d" transform="translate(-124.423 -392) translate(124.423 392)">
                              <rect width="140" height="37" rx="4" stroke="none"/>
                              <rect width="140" height="36" y=".5" fill="none" x=".5" rx="3.9"/>
                          </g>
                          <g opacity="0.798">
                              <g>
                                  <g>
                                      <path fill="#148c8d" d="M144.355 138.571h-2.667V135.9a.667.667 0 0 0-1.333 0v2.667h-2.667a.667.667 0 1 0 0 1.333h2.667v2.667a.667.667 0 1 0 1.333 0V139.9h2.667a.667.667 0 0 0 0-1.333z" transform="translate(-124.423 -392) translate(128 400.661) translate(6.423 6.339) translate(-137.022 -135.238)"/>
                                  </g>
                              </g>
                          </g>
                          <text fill="#148c8d" font-family="SourceSansPro-Semibold, Source Sans Pro" font-size="12px" font-weight="600" letter-spacing="0.03em" transform="translate(-124.423 -392) translate(150.423 414)">
                              <tspan x="0" y="0">ADD NEW ADDRESS</tspan>
                          </text>
                        </g>
                      </svg>
                    </div>
                  </div>
              </div>
              <div class="address-wrapper" v-if="buyNowAddresses.length">
                  <div class="row header-text pt-3" style="font-size: larger;">
                      <div class="col">
                          <span style="float: left; padding-left: 1rem;">DELIVER TO</span>
                      </div>
                      <div class="col" style="color: teal;">
                          <span @click="addAddress" style="float: right; padding-right: 0.3rem;">ADD ADDRESS</span>
                      </div>
                  </div>
                  <div class="address-cards" :class="buyNowAddresses.length >1 ? 'd-flex flex-row' : ''">
                      <div class=" mt-2 mb-3" :class="[selectedAddId === add.id ? 'addCard-active' : 'addCard', buyNowAddresses.length === 1 ? 'col-11': 'col-6']" v-for="(add, index) in buyNowAddresses" :key="index">
                        <label style="margin-bottom: 0;width: 98%;" :for="'addresschk' + add.id">
                          <div class="col-12 mt-2">
                              <div class="col-11">
                                  <span v-if="buyNowAddresses.length ===1"><b>{{textTruncate(add.firstname,14)}}</b></span>
                                  <span v-else><b>{{textTruncate(add.firstname,8)}}</b></span>
                                  <span class="addTypeFormat pl-1 pr-1">{{add.address_type}}</span>
                              </div>
                              <div class="col-1">
                                  <svg style="height: 1rem; width: 1rem;float: right;">
                                      <path v-show="selectedAddId === add.id" xmlns="http://www.w3.org/2000/svg" id="check-mark" fill="#e2f8f8" d="M16 8a8 8 0 1 1-8-8 8 8 0 0 1 8 8z"/>
                                      <path v-show="selectedAddId === add.id" xmlns="http://www.w3.org/2000/svg" id="check-mark-2" fill="#148c8d" d="M11.536 5.462a.625.625 0 0 1 0 .884l-4.192 4.192a.625.625 0 0 1-.884 0l-2-2a.625.625 0 0 1 .884-.884L6.9 9.213l3.751-3.751a.625.625 0 0 1 .885 0zM16 8a8 8 0 1 1-8-8 8 8 0 0 1 8 8zm-1.25 0A6.75 6.75 0 1 0 8 14.75 6.746 6.746 0 0 0 14.75 8zm0 0"/>
                                  </svg>
                                  <input type="radio" name="address" :id="'addresschk' + add.id"
                                   class="collapseRadio"
                                   :value="add.id"
                                   v-on:change="selectedinput(add)"
                                   :checked="selectedAddId === add.id"/>
                              </div>
                          </div>
                          <div class="col-12 mt-2">
                              <div class="col">
                                  <span v-if="buyNowAddresses.length ===1" class="text-capitalize">{{textTruncate(add.address1 + ', ' + add.address2 + ', ' + add.address3 + ', ' + add.city + '- ' + add.postcode,50)}}</span>
                                  <span v-else class="text-capitalize">{{textTruncate(add.address1 + ', ' + add.address2 + ', ' + add.address3 + ', ' + add.city + '- ' + add.postcode ,22)}}</span>
                                  <br>
                                  <!-- <span>{{textTruncate(add.city,10)}} Pincode: {{add.postcode}}</span> -->
                              </div>
                          </div>
                        </label>
                          <div class="col-12 mt-2 mb-1">
                              <div class="col-8">
                                  <span v-show="add.is_default" style="float: left;"> Default address </span>
                              </div>
                              <div class="col-4" style="color: teal;">
                                  <span v-if="selectedAddId === add.id" @click="editAddrs(add.id)" style="float: right; padding-right: 0.3rem;"><b>EDIT</b></span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
               <div class="mt-3" v-if="this.getPurchaseReason && this.getPurchaseReason.length && showFormalisingInventory && this.getIsSouledStore">
                <Dropdown :options="this.getPurchaseReason" v-model="selectedReason"/>
              </div>
              <!-- voucher & coupon section -->
              <div class="voucherIcon card pt-2" style="border-top: 2px solid #ebebeb !important;">
                <div class="col-12" id="voucherSise" role="tablist">
                  <div role="tab" class="mb-0 pr-2 accordianheading collapsepadding pl-1 pr-3" id="showVouchers" data-toggle="collapse" data-parent="#voucherSise" href="#collapseVouchers" aria-expanded="false" aria-controls="collapseVouchers">
                    <label for="" style="cursor:pointer;" class="header-text text-left px-2">
                      <span v-if="isTSSCorpProduct">Apply Coupon</span>
                      <span v-else>Apply Coupon / Gift Vouchers  </span>
                      <i style="cursor:pointer;" class="fa fa-angle-down" aria-hidden="true"></i>
                    </label>
                  </div>
                </div>
                <div class="row collapse pb-3" id="collapseVouchers"
                  role="tabpanel" aria-labelledby="voucherSise"
                >
                  <div class="card-block py-0">
                    <div class="discCard" v-if="showCouponFieldForExc || buyNow_exclusiveProduct || !buyNow_isExclusive">
                      <discount-code ref="modal1" :uptotal="totalamt" :upgst="gstamt" @updategst="gstamt = $event" @updateTotal="totalamt = $event" :discAmt="discountAmnt" @updisc="discountAmnt=$event" :callerComp="'buyNow'"></discount-code>
                    </div>
                    <gift-voucher v-if="!isTSSCorpProduct" :callerComp="'buyNow'"></gift-voucher>
                  </div>
                </div>
              </div>
              <div class="payment-methods-wrapper">
                <div class="row header-text pt-2">
                    <div class="col">
                      <span style="float: left; padding-left: 1rem;">PAYMENT METHOD </span>
                    </div>
                </div>
                <div class="payment-options-wrap">
                  <!-- <Gokwik/> -->
                    <saved-cards v-if="cards.length > 0" :buyNowMobile="'buynowMobile'" :cards="cards" ref='savedCards' :setPayMethod="setPayMethod" :payopt="payopt"></saved-cards>
                    <!-- <div class="pt-1 pb-2 text-center" style="background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.2));" v-if="tapOtherPaymentVisible" @click="showOtherPaymentOptions">
                      <span id="tapOtherPayment" class="text-capitalize">tap here for other payment options</span>
                    </div> -->
                    <div class="other-payment-options card" v-if="isOtherPaymentVisible">
                      <div class="row" id="paymentSise" role="tablist">
                          <div role="tab" class="col-12 mb-0 pr-2 collapsepadding" id="showPayments" data-toggle="collapse" data-parent="#paymentSise" href="#collapsePayments" aria-selected="true" aria-expanded="true" aria-controls="collapsePayments">
                            <label for="" style="cursor:pointer;float: left; " class="">Other Payment Options</label>
                            <i style="cursor:pointer;" class="mr-3 fa fa-angle-down" aria-hidden="true"></i>
                          </div>
                          <div class="row collapse show pb-2 paymentOverflow" id="collapsePayments" role="tabpanel" aria-labelledby="paymentSise">
                            <div id="accordionside" role="tablist" aria-multiselectable="true" class="cusTabs accordiontabs">
                                <!-- TSS Money -->
                                <div class="card tss-money" v-if="parseInt(user.tss_money) !== 0" :style="parseInt(user.tss_money) === 0 || buyNow_togPlaceOrderStatus ? 'pointer-events: none;' : null" @click="applyTSSMoney('tssMoney')">
                                  <div :style="parseInt(user.tss_money) === 0 || buyNow_togPlaceOrderStatus ? 'background: #f1f1f1; margin-bottom: -1px;' : 'margin-bottom: -1px;'" class="card-header" :class="{'active-tab': UsedTSSMoney === 'tssMoney'}" role="tab">
                                      <div class="customradio collapsepadding pt-2 pb-2"  data-toggle="collapse" data-parent="#accordionside" href="#collapseSix"
                                        aria-expanded="false" aria-controls="collapseSix" id="codbox">
                                        <label for="" class=" f16" style="width: 100%;">
                                          <img data-v-17aa677c="" data-src="https://tss-static-images.gumlet.io/icons/tss-money.png" class="tss-money-icon" alt="The Souled Store Money">
                                          <b style="color: #282c3f;">TSS Money</b>
                                          <span :style="parseInt(user.tss_money) === 0 ? 'background: #f1f1f1;' : null" class="payment-check"></span>
                                          <span style="float: right;mragin-left: 5px; font-size: 13px; font-weight: 500 float: right;padding-right: 7px;margin-top: 8px;">(Balance: ₹ {{parseFloat(user.tss_money - usedTssMoney).toFixed(2)}})</span>
                                        </label>
                                      </div>
                                  </div>
                                  <div id="collapseSix" class="collapsed col-md-4 col-4 text-right" role="tabpanel"
                                      aria-labelledby="headingSix">
                                  </div>
                                </div>
                                <div class="card" v-if='upis.length !== 0'>
                                  <div class="card-header" @click="setPayMethod('upi')" :class="{'active-tab': payopt === 'upi'}" role="tab" id="headingFive">
                                      <div class="customradio mb-0 accordianheading collapsepadding" data-toggle="collapse" data-parent="#accordionside" href="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                        <label for="" class=" f16"><b style="color: #282c3f;">UPI</b></label>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                      </div>
                                  </div>
                                  <div id="collapseFive" class="collapse" role="tabpanel" aria-labelledby="headingFive">
                                      <div class="card-block">
                                        <upi-input callerComp="buyNow" ref="upiSelector"></upi-input>
                                      </div>
                                  </div>
                                </div>
                                <div class="card">
                                  <div class="card-header" @click="setPayMethod('wallet')" :class="{'active-tab': payopt === 'wallet'}" role="tab" id="headingThree">
                                      <div class="customradio mb-0 accordianheading collapsepadding" data-toggle="collapse" data-parent="#accordionside" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        <label for="" class=" f16"><b style="color: #282c3f;">Wallets</b></label>
                                        <!-- <span class="offer-accordian">Offers</span> -->
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                      </div>
                                  </div>
                                  <div id="collapseThree" class="collapse" role="tabpanel" aria-labelledby="headingThree">
                                      <div class="card-block">
                                        <wallet-input callerComp="buyNow" ref="walletSelector"></wallet-input>
                                      </div>
                                  </div>
                                  <div class="card">
                                      <div class="card-header" @click="setPayMethod('dcc')" :class="{'active-tab': payopt === 'dcc'}" role="tab" id="headingOne">
                                        <div class="customradio mb-0 accordianheading collapsepadding" data-toggle="collapse" data-parent="#accordionside" href="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                            <label for="" class=" f16"><b style="color: #282c3f;">Credit &amp; Debit Cards</b></label>
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </div>
                                      </div>
                                      <div id="collapseOne" class="collapse" role="tabpanel" aria-labelledby="headingOne">
                                        <div class="card-block">
                                            <card-input ref='cardInput' :saveCard="saveCard" :toggleSavecard="toggleSavecard"></card-input>
                                        </div>
                                      </div>
                                  </div>
                                  <div class="card">
                                      <div class="card-header" @click="setPayMethod('nb')" :class="{'active-tab': payopt === 'nb'}" role="tab" id="headingTwo">
                                        <div class="customradio mb-0 accordianheading collapsepadding" data-toggle="collapse" data-parent="#accordionside" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            <label for="" class=" f16"><b style="color: #282c3f;">Netbanking</b></label>
                                            <i class="fa fa-angle-down" aria-hidden="true"></i>
                                        </div>
                                      </div>
                                      <div id="collapseTwo" class="collapse" role="tabpanel" aria-labelledby="headingTwo">
                                        <div class="card-block">
                                            <net-banking-input callerComp="buyNow" ref="netBankingInput"></net-banking-input>
                                        </div>
                                      </div>
                                  </div>
                                  <!--                        <div class="card cod" @click="setPayMethod('cod')" v-if='buyNow_cod_details.valid && calculations.total > 0 && !isBirthdaySale'>-->
                                  <div class="card cod" @click="setPayMethod('cod')" v-if='buyNow_cod_details.valid && buyNowCalculations.total <= COD_LIMIT'>
                                      <div class="card-header" :class="{'active-tab': payopt === 'cod'}" role="tab">
                                        <div class="customradio collapsepadding pt-2 pb-2"  data-toggle="collapse" data-parent="#accordionside" href="#collapseFour"
                                            aria-expanded="false" aria-controls="collapseFour" id="codbox">
                                            <label for="" class=" f16"><b style="color: #282c3f;">COD</b></label>
                                            <span class="payment-check"></span>
                                            <p class="mb-0 pay-recommend">We recommend making prepaid payments to ensure your deliveries are contactless.</p>
                                        </div>
                                      </div>
                                      <div id="collapseFour" class="collapsed col-md-4 col-4 text-right" role="tabpanel"
                                        aria-labelledby="headingFour">
                                      </div>
                                  </div>
                                  <div  class="card cod bgcolor" v-else-if='!buyNow_cod_details.valid && this.cod_message.includes("₹4000") && buyNowCalculations.total > COD_LIMIT'>
                                    <div class="card-header bgcolor" :class="{'active-tab': payopt === 'cod'}" role="tab">
                                        <div class="customradio pt-2 pb-2"  data-toggle="collapse" data-parent="#accordionside" href="#collapseFour"
                                              aria-expanded="false" aria-controls="collapseFour" id="">
                                          <label for="" class=" f16">COD</label>
                                          <span  class="payment-check bgcolor"></span>
                                          <p v-if="!bannerPlaceHolderCodMessage && !bannerPlaceHolderCodMessage.text" class="mb-0 pay-recommend">We recommend making prepaid payments to ensure your deliveries are contactless.</p>
                                        </div>
                                    </div>
                                    <div id="collapseFour" class="collapsed col-md-4 col-4 text-right" role="tabpanel"
                                        aria-labelledby="headingFour">
                                    </div>
                                    <div class="form-check-label col-12 justify-content-center">
                                        <p v-bind:style="[bannerPlaceHolderCodMessage.styles]" class="upi-message text-center" 
                                          v-if="bannerPlaceHolderCodMessage && Object.keys(bannerPlaceHolderCodMessage).length">
                                          {{bannerPlaceHolderCodMessage.text}}
                                        </p>
                                    </div>
                                  </div>
                                  <!-- COD banner placeholder -->
                                  <div class="form-check-label col-12 justify-content-center" v-if='buyNow_cod_details.valid && buyNowCalculations.total <= COD_LIMIT'>
                                      <p v-bind:style="[bannerPlaceHolderWithoutCodWeb.styles]" class="upi-message text-center" 
                                        v-if="bannerPlaceHolderWithoutCodWeb && Object.keys(bannerPlaceHolderWithoutCodWeb).length">
                                        {{bannerPlaceHolderWithoutCodWeb.text}}
                                      </p>
                                  </div>
                                </div>
                                <div class="card" @click="setPayMethod('prepaid')" v-if="UsedTssMoneyAndTotalPayabelIsZero">
                                  <div class="card-header" :class="{'active-tab': payopt === 'prepaid'}" role="tab">
                                      <div class="customradio">
                                        <input data-toggle="collapse" data-parent="#accordionside" href="#collapseFour"
                                            aria-expanded="false" aria-controls="collapseFour" class="collapsepadding " id="codbox"
                                            type="radio" name="cartwidgets[]" v-model="payopt" value="prepaid">
                                        <label for="" class=" f16"> &nbsp;Prepaid</label>
                                        <span class="payment-check"></span>
                                      </div>
                                  </div>
                                  <div id="collapseFour" class="collapsed col-md-4 col-4 text-right" role="tabpanel"
                                      aria-labelledby="headingFour">
                                  </div>
                                </div>
                            </div>
                          </div>
                      </div>
                      <div id="billingPriceDetails" class="row" role="tablist">
                        <div role="tab" @click="showPriceDetailsSection('end')" class="col-12 mb-0 pr-2 collapsepadding" id="showPaymentsDetails" data-toggle="collapse" data-parent="#billingPriceDetails" href="#collapsePaymentsDetails" aria-selected="false" aria-expanded="false" aria-controls="collapsePaymentsDetails">
                          <label for="" style="cursor:pointer;float: left; " class=""><b style="color: #282c3f;">Price Details</b></label>
                          <i style="cursor:pointer;" class="mr-3 fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                        <div class="col-12 collapse pb-2 " id="collapsePaymentsDetails" role="tabpanel" aria-labelledby="collapsePaymentsDetails">
                          <!-- <div class="clearfix" style="border-top: 1px solid rgba(0,0,0,.125);"></div> -->
                          <billing-details-mobile :payMethod="payopt" :callerComp="'buyNow'" :showBillingDetails="true" :showAngle="false" :togglePriceDetails="togglePriceDetails"></billing-details-mobile>
                          <div class="clearfix"></div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="mbstickyfooter">
              <div class="mb-select-add-container row">
                <div class="col-5 price-view-details-conatiner" style="font-size: 1.1rem;" @click="showPriceDetailsSection('start')">
                  <p v-if="this.displayCodExtraAmoutBanner">{{ currencySymbol }} {{parseInt(buyNowCalculations.total + buyNowCalculations.cod_charges)}}</p>
                  <p v-else>{{ currencySymbol }} {{parseInt(buyNowCalculations.total)}}</p>
                  <p class="view-details">VIEW DETAILS</p>
                </div>
                <div class="col-7">
                  <button :disabled="disabled" @click="buyNowOrderHandler" class="btn btn-danger pointer btn-lg btn-block text-uppercase" >PLACE ORDER
                  </button>
                </div>
              </div>
            </div>
        </div>
        <new-address
          v-if="newAddressModal" style="z-index:10000;" :getUser="user" 
          :getzone="pzones" @close="newAddressModal = false"
          :callerComp="'buyNow'"
        >
        </new-address>
        <edit-address v-if="editModal" style="z-index:10000;" @close="editModal = false" 
          :userAddr="userAddress" :getzone="pzones"
          :callerComp="'buyNow'"
          :checkAreaServiceability="checkAreaServiceability"
        >
        </edit-address>
    </div>
</template>
<script>
  var $ = require('jquery')
  window.jQuery = $
  import savedCards from './saveCards.vue'
  import cardInput from '../payment/cardInput.vue'
  import netBankingInput from '../payment/netBankingInput.vue'
  import walletInput from '../payment/walletInput.vue'
  import upiInput from '../payment/upiInput.vue'
  import newAddress from './newAddress'
  import editAddress from './editAddress'
//   import SimpleVueValidation from 'simple-vue-validator'
//   var Validator = SimpleVueValidation.Validator
  import {mapGetters} from 'vuex'
  import Vue from 'vue'
  import discountCode from './discountCode.vue'
  import BillingDetailsMobile from './BillingDetailsMobile'
  import billingDetails from './billingDetails.vue'
  import giftVoucher from './giftVoucher.vue'
  import moment from 'moment/src/moment'
  import cartWidgets from './cartWidgets.vue'
  import Dropdown from './Dropdown.vue'
  // import Gokwik from './Gokwik.vue'
  import {appMixins} from '../../assets/js/appMixins'
  export default {
    mixins: [appMixins],
    components: {Dropdown, cardInput, walletInput, netBankingInput, upiInput, savedCards, newAddress, editAddress, discountCode, BillingDetailsMobile, billingDetails, giftVoucher, cartWidgets
      // , Gokwik
    },
    data () {
      return {
        tssMoney: '',
        usedTssMoney: 0,
        payopt: '',
        saveCard: true,
        COD_LIMIT: 4000,
        selectedAddId: null,
        newAddressModal: false,
        pzones: '',
        userAddress: '',
        isOtherPaymentVisible: true,
        tapOtherPaymentVisible: false,
        editModal: false,
        totalamt: null,
        gstamt: null,
        discountAmnt: null,
        showLoginToApply: false,
        isCODPopup: false,
        deliveryEstimateMsg: 'Expected Delivery ...',
        msg: {
          0: 'Oops! Your transaction could not be completed due to payment failure. If the amount has been debited from your account, it will be credited back to your account automatically within 7 working days. You can try placing this order again using another payment method.',
          1: 'Oops! Your transaction could not be completed due to payment failure. You can try placing this order again using another payment method.',
          2: 'Oops! Invalid user information, kindly check and try again.',
          3: 'Your transaction authorization is in progress. If the amount has been debited from your account, you will receive an order confirmation mail shortly.',
          4: 'Oops! Your Payment was not initiated. Kindly try again.',
          5: 'Oops! Your transaction could not be completed as bank refused the transaction. You can try placing this order again using another payment method.'
        },
        error_code: this.$route.query.msg,
        cartdata: {'gstcart': {}, 'cart': {}},
        disabled: false,
        displayCodExtraAmoutBanner: false,
        placeOrder: false,
        billingDetailsVisibility: false,
        cod_message: '',
        orderPlatform: '',
        selectedReason: null,
        failedData: {},
        nonCodOrder: this.$route && this.$route.query && this.$route.query.order
      }
    },
    props: ['closeBuyNow'],
    methods: {
      getPaymentStatus (statusCode) {
        const statusMap = {
          1: 'Pending',
          2: 'Cancelled',
          3: 'Partially Paid',
          4: 'Paid',
          5: 'Refunded',
          6: 'Initiated',
          7: 'Failed',
          8: 'Captured',
          9: 'Paid/Refunded'
        }
        return statusMap[statusCode] || 'Unknown'
      },
      trackOrderFailed (cart, calculations) {
        // Dynamically create an iframe for the order failed data
        let demothings = this.getMeta(cart, 'payment_details')
        let cartContents = cart && cart.products.items
        const productInfoArray = cartContents && cartContents.map(item => ({
          product_id: String(item.parent_prod_id),
          product_name: String(item.product),
          sku: String(item.prod_id),
          quantity: Number(item.quantity),
          unit_price: Number(item.price),
          total_price: Number(item.main_sub_total),
          product_attributes: { color: String(item.color), size: String(item.size) },
          product_level_discount_value: item.price - (this.isExclusive && item.exclusive_price ? item.exclusive_price : ((item.splPrice || item.spl_price) && (item.splPrice > 0 || item.spl_price)) ? item.splPrice || item.spl_price : item.price)
        }))
        this.orderFailedData = {
          user_id: this.user && this.user.user_id,
          order_id: String(this.order || this.nonCodOrder),
          order_time: new Date().toISOString(),
          payment_method: String(demothings.payment_method),
          payment_status: 'NA', // Map code to status name              ,
          product_info: productInfoArray,
          total_order_value: Number((calculations.total || 0) + (calculations.used_reward_points || 0) + (calculations.gift_voucher_value || 0)),
          total_discount_value: Number(calculations.total_savings + calculations.coupon_discount),
          coupon_value: (calculations.coupon_discount || 0),
          coupon_info: (this.coupon && this.coupon.coupon) || 'NA',
          shipping_value: (calculations && calculations.shipping_charges) || 0,
          tax_value: (calculations && calculations.gst_total) || 0
        }
        const iframe = document.createElement('iframe')
        iframe.style.width = '0'
        iframe.style.height = '0'
        iframe.style.border = '0'
        iframe.style.display = 'none'
        // Construct the URL with encoded order failed data
        const failedData = encodeURIComponent(JSON.stringify(this.orderFailedData)) // Reuse the same data
        iframe.src = `https://catalog2.hypd.store/affiliate/tracking?merchant=SOULEDSTORE&event=failure&value=${failedData}`
        // Append iframe to the DOM
        document.body.appendChild(iframe)
        // Remove iframe after a short delay to clean up
        iframe.onload = () => {
          setTimeout(() => document.body.removeChild(iframe), 7000)
        }
        iframe.onerror = () => {
          document.body.removeChild(iframe)
        }
      },
      toggleLoginToApply () {
        this.showLoginToApply = !this.showLoginToApply
      },
      goToLogin () {
        this.$router.push(`/login?redirect=${this.$route.path}`)
      },
      applyTSSMoney (tssMoneyOpt) {
        if (!this.buyNow_togPlaceOrderStatus) {
          let state = false
          let tssPointsStatus = false
          this.tssMoney = this.tssMoney === 'tssMoney' && tssMoneyOpt === 'tssMoney' ? '' : tssMoneyOpt
          if (this.tssMoney) {
            state = true
            this.payopt = 'prepaid'
          }
          if (this.buyNowCalculations &&
            this.buyNowCalculations.used_tss_points &&
            this.buyNowCalculations.used_tss_points > 0) {
            tssPointsStatus = true
          }
          this.$store.dispatch('BUYNOW_APPLY_WALLET', {'state': state, tss_points_status: tssPointsStatus})
          this.$store.commit('GTAG_EVENT', {eventName: 'buyNow_appliedTssMoney_click', payload: {route: Vue.ls.get('routeObj')}})
          this.$store.commit('CT_BUYNOW_MOB_WEB_APPLIEDTSSMONEY')
          this.$store.commit('FB_BUYNOW_MOB_WEB_APPLIEDTSSMONEY')
        }
      },
      toggleSavecard () {
        this.saveCard = !this.saveCard
      },
      setPayMethod (option) {
        this.payopt = this.payopt === 'cod' && option === 'cod' ? '' : option
        // show addition charges banner for cod
        this.displayCodExtraAmoutBanner = false
        if (this.payopt === 'cod') {
          this.displayCodExtraAmoutBanner = true
          this.$store.commit('GTAG_EVENT', {eventName: 'buyNow_codPayment_click', payload: {route: Vue.ls.get('routeObj')}})
          this.$store.commit('CT_BUYNOW_MOB_WEB_CODPAYMENTCLICK')
          this.$store.commit('FB_BUYNOW_MOB_WEB_CODPAYMENTCLICK')
        }
        // check if used TSS Money is checked unchecked it
        if (this.tssMoney && option !== 'prepaid' && this.buyNowCalculations.total === 0) {
          this.applyTSSMoney(this.tssMoney)
        }
        this.disabled = false
      },
      toggleCODPopUp () {
        this.isCODPopup = !this.isCODPopup
        if (this.isCODPopup === false) {
          this.$store.commit('GTAG_EVENT', {eventName: 'cstm_ga_cod_pop_up_click_here_clicked', payload: {}})
          this.$store.commit('GTAG_EVENT', {eventName: 'Transaction_Failure', payload: {}})
          this.trackOrderFailed(this._buyNowCart, this.buyNowCalculations)
        }
      },
      getAddressList () {
        this.$store.dispatch('GET_ADDRESSES')
      },
      textTruncate: function (str, length, ending) {
        if (length == null) {
          length = 100
        }
        if (ending == null) {
          ending = '...'
        }
        if (str.length > length) {
          return str.substring(0, length - ending.length) + ending
        } else {
          return str
        }
      },
      addNewAddress () {
        this.$store.commit('GTAG_EVENT', {eventName: 'buyNow_addNewAddress_click', payload: {route: Vue.ls.get('routeObj')}})
        this.$store.commit('FB_BUYNOW_MOB_WEB_ADDNEWADDRESS')
        this.newAddress()
      },
      addAddress () {
        this.$store.commit('GTAG_EVENT', {eventName: 'buyNow_addAddress_click', payload: {route: Vue.ls.get('routeObj')}})
        this.$store.commit('CT_BUYNOW_MOB_WEB_ADDADDRESS')
        this.$store.commit('FB_BUYNOW_MOB_WEB_ADDADDRESS')
        this.newAddress()
      },
      newAddress () {
        this.$store.dispatch('ZONES', this.countryId)
        this.newAddressModal = true
      },
      showPriceDetailsSection: function (direction) {
        let scrollDomPrice = direction === 'end' ? document.getElementsByClassName('total-amount') && document.getElementsByClassName('total-amount').length > 0 && document.getElementsByClassName('total-amount')[0] : document.getElementById('billingPriceDetails')
        if (scrollDomPrice) {
          scrollDomPrice.scrollIntoView({behavior: 'smooth', block: 'start'})
        }
      },
      editAddrs (aid) {
        this.$store.dispatch('ZONES', this.countryId)
        this.$store.dispatch('GET_ADDRESS', aid).then(response => {
          this.userAddress = response.data
          this.editModal = true
        }, error => {
          console.log(error)
        })
        // this.$store.commit('GTAG_EVENT', {eventName: 'add_shipping_info', payload: {route: Vue.ls.get('routeObj'), items: [aid]}})
      },
      selectedinput (addr) {
        this.selectedAddId = addr.id
        this.$store.dispatch('SET_BUYNOW_ORDER_ADDRESS', addr.id)
        this.$store.commit('GTAG_EVENT', {eventName: 'add_shipping_info', payload: {value: this.getUserTatvicBuyNowItem[0].price, items: this.getUserTatvicBuyNowItem}})
        // this.$store.commit('GTAG_EVENT', {eventName: 'buyNow_selectAddress_click', payload: {route: Vue.ls.get('routeObj'), address: addr}})
        this.$store.commit('CT_BUYNOW_MOB_WEB_SELECTADDRESS', addr)
        this.$store.commit('FB_BUYNOW_MOB_WEB_SELECTADDRESS', addr)
      },
      togglePriceDetails () {},
      showAddessSelectPopUp () {
        Vue.toasted.show(this.selectedAddId ? 'Delivery is not serviceable at this Pincode' : 'Please add address to continue.', {
          theme: 'primary',
          className: 'toasted-customred',
          position: 'top-right',
          duration: 5000
        })
      },
      applyWidgets (ref, item) {
        if (this.$refs[ref][0].checked) {
          this.$store.dispatch('UPDATE_BUYNOW_CART', {operation: 'set', type: 'widgets', data: item})
        } else {
          this.$store.dispatch('UPDATE_BUYNOW_CART', {operation: 'delete', type: 'widgets', data: item})
        }
      },
      buyNowOrderHandler () {
        if (this.selectedAddId && this.areaServiceableData && Object.keys(this.areaServiceableData).length && this.areaServiceableData.serviceability === 1) {
          this.disabled = true
          this.$store.dispatch('PROCESS_ORDER_BUYNOW', this._buyNowCart).then((res) => {
            this.$store.commit('IS_BUYNOW_CHECKOUT', true)
            this.paymentProcess()
          })
          this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'add_payment_info',
            payload: {
              currency: 'INR',
              value: this.buyNowCalculations.total,
              payment_type: this.payopt || 'NA',
              coupon: (this.coupon && this.coupon.coupon) || 'NA',
              items: this.getUserTatvicBuyNowItem,
              tss_points: (this.buyNowCalculations.used_tss_points || 0)
            }
          })
        } else {
          this.showAddessSelectPopUp()
        }
      },
      paymentProcess () {
        let cartData = null
        let expiryDetails = null
        this.$store.dispatch('USER').then(res => {
          expiryDetails = res && res.exclusive
          this.$store.dispatch('BUYNOW_CART_DATA').then((resCart) => {
            cartData = resCart
            this.$toasted.clear()
            if (this.getIsSouledStore && !this.selectedReason && this.showFormalisingInventory) {
              this.showError('Please select a reason to purchase')
              return
            }
            if (!this.placeOrder) {
              this.$store.commit('GTAG_EVENT', {eventName: 'buyNow_finish', payload: {route: Vue.ls.get('routeObj')}})
              this.$store.commit('GTAG_EVENT', {eventName: 'fb_buyNow_finish', payload: {route: Vue.ls.get('routeObj')}})
              switch (this.payopt) {
                case 'sc':
                  const z = new FormData()
                  const cardDetails = this.$refs.savedCards.makeCard()
                  if (this.$refs.savedCards.CVVValidator()) {
                    this.showError('Please check card details & try again')
                    this.disabled = false
                    break
                  }
                  z.set('card_number', cardDetails.card_number)
                  z.set('card_exp_month', cardDetails.card_exp_month)
                  z.set('card_exp_year', cardDetails.card_exp_year)
                  z.set('card_security_code', cardDetails.cvv)
                  z.set('name_on_card', cardDetails.name_on_card)
                  z.set('merchant_id', process.env.JUSPAY_MERCHANT)
                  this.$store.dispatch('BUYNOW_PLACE_ORDER', {purchase_reason_id: this.selectedReason && this.selectedReason.id, payment_method: 'dcc', card_pay_type: 'sc', card_security_code: cardDetails.cvv, additional_info: cardDetails.card_token, cartData, expiryDetails, order_platform: this.orderPlatform})
                  this.disabled = false
                  this.placeOrder = true
                  break
                case 'dcc':
                  const y = new FormData()
                  const card = this.$refs.cardInput.makeCard()
                  if (!card.valid) {
                    this.showError('Please check card details & try again')
                    this.disabled = false
                    break
                  }
                  y.set('card_number', card.number)
                  y.set('card_exp_month', card.month)
                  y.set('card_exp_year', card.year)
                  y.set('card_security_code', card.cvv)
                  y.set('name_on_card', card.name)
                  y.set('merchant_id', process.env.JUSPAY_MERCHANT)

                  if (this.saveCard) {
                    y.set('customer_email', this.user.email)
                    y.set('customer_id', this.user.id)
                    this.$store.dispatch('ADD_CARD', {
                      'card_number': card.number,
                      'card_exp_year': card.year,
                      'card_exp_month': card.month,
                      'name_on_card': card.name,
                      'customer_email': this.user.email,
                      'merchant_id': process.env.JUSPAY_MERCHANT
                    })
                  }
                  this.$store.dispatch('CREATE_TOKEN', y).then(token => {
                    this.$store.dispatch('BUYNOW_PLACE_ORDER', {purchase_reason_id: this.selectedReason && this.selectedReason.id, payment_method: this.payopt, additional_info: token, cartData, expiryDetails, order_platform: this.orderPlatform})
                    this.disabled = false
                    this.placeOrder = true
                  })
                  break
                case 'cod':
                  this.$store.dispatch('BUYNOW_PLACE_ORDER', {purchase_reason_id: this.selectedReason && this.selectedReason.id, payment_method: this.payopt, cartData, expiryDetails, isGokwik: true, order_platform: this.orderPlatform})
                  this.disabled = true
                  this.placeOrder = true
                  break
                case 'nb':
                  if (this.$refs.netBankingInput.bank === '<>') {
                    this.showError()
                    this.disabled = false
                    break
                  }
                  this.$store.dispatch('BUYNOW_PLACE_ORDER', {
                    purchase_reason_id: this.selectedReason && this.selectedReason.id,
                    payment_method: this.payopt,
                    additional_info: this.$refs.netBankingInput.bank,
                    cartData,
                    expiryDetails,
                    order_platform: this.orderPlatform
                  })
                  break
                case 'wallet':
                  let walletObj = this.$refs.walletSelector.getWallet()
                  if (walletObj.name === '<>') {
                    this.showError()
                    this.disabled = false
                    break
                  }
                  this.$store.dispatch('BUYNOW_PLACE_ORDER', {purchase_reason_id: this.selectedReason && this.selectedReason.id, payment_method: this.payopt, additional_info: walletObj.name, cartData, expiryDetails, order_platform: this.orderPlatform})
                  break
                case 'prepaid':
                  this.$store.dispatch('BUYNOW_PLACE_ORDER', {purchase_reason_id: this.selectedReason && this.selectedReason.id, payment_method: this.payopt, cartData, expiryDetails, order_platform: this.orderPlatform})
                  break
                case 'upi':
                  this.$refs.upiSelector.getUpi().then((response) => {
                    if (!response.paymentSelected) {
                      this.disabled = false
                      this.showError()
                    } else if (response.paymentSelected !== 'GOKWIKUPI' && !response.upiObj.value) {
                      this.showError('Please enter the details')
                    } else {
                      let upiInfo = {purchase_reason_id: this.selectedReason && this.selectedReason.id, payment_method: this.payopt, additional_info: response.upiObj, cartData, expiryDetails, order_platform: this.orderPlatform}
                      if (response.paymentSelected === 'GOKWIKUPI') {
                        upiInfo = {...upiInfo, payment_method: 'GOKWIKUPI', isGokwik: true}
                      }
                      this.$store.dispatch('BUYNOW_PLACE_ORDER', upiInfo)
                    }
                  })
                  break
                default:
                  this.disabled = false
                  this.showError()
              }
            }
          })
        })
      },
      showError (err) {
        this.$toasted.show(err || 'Please select a payment method to continue', {
          theme: 'primary',
          className: 'toasted-customred',
          position: 'top-right',
          duration: 3000
        })
      },
      checkAreaServiceability () {
        if (this.selectedAddId) {
          this.$store.dispatch('GET_ADDRESS', this.selectedAddId).then(response => {
            const pinCode = response.data.postcode
            this.$store.dispatch('CHECK_AREA_SERVICEABLE', pinCode)
          })
        }
      }
    },
    computed: {
      ...mapGetters({
        buyNow_togPlaceOrderStatus: 'buyNow_togPlaceOrderStatus',
        authStatus: 'authStatus',
        user: 'user',
        upis: 'upis',
        buyNow_cod_details: 'buyNow_cod_details',
        payMethods: 'payMethods',
        bannerPlcaeHolderData: 'bannerPlcaeHolderData',
        cards: 'cards',
        countryId: 'countryId',
        addresses: 'addresses',
        buyNowCalculations: 'buyNowCalculations',
        _buyNowCart: '_buyNowCart',
        buyNow_site_config: 'buyNow_site_config',
        buyNow_exclusiveProduct: 'buyNow_exclusiveProduct',
        buyNow_product_count: 'buyNow_product_count',
        buyNow_addedWidgets: 'buyNow_addedWidgets',
        buyNow_cart_address: 'buyNow_cart_address',
        areaServiceableData: 'areaServiceableData',
        getUserTatvicBuyNowItem: 'getUserTatvicBuyNowItem',
        getPurchaseReason: 'getPurchaseReason',
        getIsSouledStore: 'getIsSouledStore',
        currencySymbol: 'currencySymbol',
        order: 'order',
        isExclusive: 'isExclusive'
      }),
      UsedTSSMoney: function () {
        let usedTssMoney = this._buyNowCart && this._buyNowCart.meta && this._buyNowCart.meta.items && this._buyNowCart.meta.items.length && this._buyNowCart.meta.items[this._buyNowCart.meta.index['tss_money']].used_tss_money
        if (usedTssMoney === 0) {
          this.tssMoney = ''
          this.usedTssMoney = usedTssMoney
        } else {
          this.tssMoney = 'tssMoney'
          this.usedTssMoney = usedTssMoney
          return 'tssMoney'
        }
      },
      showFormalisingInventory () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Payment Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_FORMALISING_INVENTORY_WEB')
      },
      bannerPlaceHolderWithoutCodWeb: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let bannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() &&
              bannerData.status === true &&
              bannerData.product_type.toLowerCase() === 'COD_WEB'.toLowerCase())
          if (bannerObj && Object.keys(bannerObj).length) {
            let bannerPhObj = {}
            bannerPhObj.styles = {
              backgroundColor: bannerObj.banner_color,
              color: bannerObj.banner_text_color
            }
            bannerPhObj.text = bannerObj.tag_text
            bannerPhObj.status = bannerObj.status
            return bannerPhObj
          }
        }
      },
      bannerPlaceHolderCodMessage: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let bannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() &&
              bannerData.status === true &&
              bannerData.product_type.toLowerCase() === 'MAXIMUM_COD_MSG'.toLowerCase())
          if (bannerObj && Object.keys(bannerObj).length) {
            let bannerPhObj = {}
            bannerPhObj.styles = {
              backgroundColor: bannerObj.banner_color,
              color: bannerObj.banner_text_color
            }
            bannerPhObj.text = bannerObj.tag_text
            bannerPhObj.status = bannerObj.status
            return bannerPhObj
          }
        }
      },
      bannerPlaceHolderForAllPay: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let bannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Payment'.toLowerCase() &&
              bannerData.status === true)
          if (bannerObj && Object.keys(bannerObj).length) {
            let bannerPhObj = {}
            bannerPhObj.styles = {
              backgroundColor: bannerObj.banner_color,
              color: bannerObj.banner_text_color
            }
            bannerPhObj.text = bannerObj.tag_text
            bannerPhObj.status = bannerObj.status
            return bannerPhObj
          }
        }
      },
      // banner only when COD is selected
      bannerPlaceHolderWithCOD: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let bannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() &&
              bannerData.status === true &&
              bannerData.product_type.toLowerCase() === 'DISCOUNT_WITH_COD'.toLowerCase())
          if (bannerObj && Object.keys(bannerObj).length) {
            let bannerPhObj = {}
            bannerPhObj.styles = {
              backgroundColor: bannerObj.banner_color,
              color: bannerObj.banner_text_color
            }
            bannerPhObj.text = bannerObj.tag_text
            bannerPhObj.status = bannerObj.status
            return bannerPhObj
          }
        }
      },
      UsedTssMoneyAndTotalPayabelIsZero: function () {
        let usedTssMoney = this._buyNowCart && this._buyNowCart.meta && this._buyNowCart.meta.items && this._buyNowCart.meta.items.length && this._buyNowCart.meta.items[this._buyNowCart.meta.index['tss_money']].used_tss_money
        let amount = this._buyNowCart && this._buyNowCart.meta && this._buyNowCart.meta.items && this._buyNowCart.meta.items.length && this._buyNowCart.meta.items[this._buyNowCart.meta.index['calculations']].total
        if (amount === 0 && usedTssMoney === 0) return true
        else return false
      },
      showCouponFieldForExc () {
        return this.buyNow_site_config && this.buyNow_site_config.is_exclusive_discount_visible
      },
      isTSSCorpProduct () {
        if (this._buyNowCart && this._buyNowCart.products && this._buyNowCart.products.items && this._buyNowCart.products.items.length === 1 && !(this.buyNow_cartvouchers && this.buyNow_cartvouchers.length)) {
          return this.isCorporateProduct(this._buyNowCart.products.items[0].artist_slug)
        }
      },
      buyNowAddresses () {
        return this.addresses && this.addresses.slice(0, -1)
      }
    },
    watch: {
      'buyNow_cod_details' () {
        this.cod_message = this.buyNow_cod_details.message
        if (this.buyNow_cod_details && this.buyNow_cod_details.valid) {
        } else {
          this.payopt = ''
          this.setPayMethod('')
        }
        if (this.msg[this.error_code]) {
          if (this.error_code === '1' && this.buyNow_cod_details.valid && this.buyNowCalculations.total > 0 && this.buyNowCalculations.total <= this.COD_LIMIT) {
            this.toggleCODPopUp()
            this.setPayMethod('cod')
            // this.$store.commit('GTAG_EVENT', {eventName: 'cstm.ga.cod.pop.up', payload: {}})
          } else {
            this.displayError = true
          }
        }
      },
      _buyNowCart: function (_lCart) {
        let amount = _lCart && _lCart.meta && _lCart.meta.items && _lCart.meta.items.length && _lCart.meta.items[_lCart.meta.index['calculations']].total
        if (amount === 0) this.setPayMethod('prepaid')
        else {
          let pmtOptionToSet = this.payopt
          this.payopt = ''
          this.setPayMethod(pmtOptionToSet)
        }
      },
      selectedAddId (addressId) {
        if (addressId) {
          this.checkAreaServiceability()
        }
      },
      areaServiceableData (pincodeDetails) {
        if (pincodeDetails && pincodeDetails.serviceability && pincodeDetails.serviceability === 1) {
          const deliveryDate = this.$parent.$parent.formatDateToGivenFormat(moment(new Date()).add(pincodeDetails.max_estimated_days_new, 'days'), 'dddd, MMMM DD ')
          this.deliveryEstimateMsg = 'Expected Delivery by ' + deliveryDate
          this.$store.dispatch('PROCESS_ORDER_BUYNOW', this._buyNowCart)
        } else {
          this.deliveryEstimateMsg = 'Pincode not serviceable'
        }
      },
      buyNowAddresses (addresses) {
        if (addresses && addresses.length) {
          const defaultAddress = addresses.find(address => address.is_default)
          if (defaultAddress && Object.keys(defaultAddress).length) {
            this.selectedAddId = defaultAddress.id
            this.$store.dispatch('SET_BUYNOW_ORDER_ADDRESS', defaultAddress.id)
          } else {
            this.selectedAddId = addresses[0] && addresses[0].id
            this.$store.dispatch('SET_BUYNOW_ORDER_ADDRESS', addresses[0] && addresses[0].id)
          }
        } else {
          this.selectedAddId = ''
        }
      }
    },
    mounted: function () {
      this.$store.dispatch('GET_PAYMETHODS')
      let localCartMeta = Vue.ls.get('localBuyNowCart').meta
      let amount = this.$store.getters.buyNowCalculations.total || localCartMeta.items[localCartMeta.index['calculations']].total
      if (amount === 0) {
        this.setPayMethod('prepaid')
      }
      this.$store.dispatch('CHECK_ELIGIBILITY', {amount: JSON.stringify(amount)})
      this.$store.dispatch('STORED_CARDS')
      this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'begin_checkout',
        payload: {
          currency: 'INR',
          value: this.buyNowCalculations.total,
          items: this.getUserTatvicBuyNowItem,
          tss_points: (this.buyNowCalculations.used_tss_points || 0),
          coupon: (this.coupon && this.coupon.coupon) || 'NA'
        }
      })
    },
    created () {
      this.$parent.isDesktop ? this.orderPlatform = 'WEB_DESKTOP' : this.orderPlatform = 'WEB_MOBILE'
      this.getAddressList()
    },
    beforeDestroy () {
      document.body.classList.remove('noscroll')
    }
  }
  
</script>
<style scoped>
.bgcolor {background: #f1f1f1 !important;}
.bgcolormessage{color: rgb(229, 73, 73);background: rgb(182, 192, 202) none repeat scroll 0% 0%}
.buyNow-wrapper{
  left: 0;
  width: 100%;
  position: fixed;
  z-index: 9999;
  bottom: 59px;
  transition: 0.3s;
  max-height: 435px;
  overflow-y: auto;
  overflow-x: hidden;
}
.buyNow-wrapper-total{
    height: 100%;
    width: 100%;
    background-color: #ffffff;
    border-top-right-radius: 25px;
    border-top-left-radius: 25px;
    transition: 0.3s;
}
.buyNowModalOverlay {
    background-color: rgba(0, 0, 0, 0.6);
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 9999;
    top: 0;
    right: 0;
    transition: 0.5s;
    overflow-x: hidden;
    overflow-y: hidden;
}
.header-text{
    width:100%;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: normal;
    text-align: center;
    color: #282c3f;
    font-size: initial;
}
.address-wrapper {
    border-top: 2px solid #ebebeb;
}
.payment-methods-wrapper {
    border-top: 2px solid #ebebeb;
}
.addCard {
  border-radius: 5px;
  border: 1px solid rgb(138, 138, 138);
  margin-left: 1rem;
}
.addCard-active {
  border: 1px solid rgb(1, 145, 145);
  border-radius: 5px;
  margin-left: 1rem;
}
.addTypeFormat {
    background: #ebebeb;
    color:rgb(89, 89, 89);
    border-radius: 3px;
}
.address-cards {
    overflow-x: auto;
}
.item2{ 

    border:0;
    border-radius: 50%;
    padding:0px;
    margin: 0;
    width: 25px;
    height:25px;
    box-shadow: 0 0 5px #6d6d6d;           
    overflow: hidden;
    display: flex;
}
.inputCvv {
    width: 35px;
    
}
input[type=password] {
    box-sizing: border-box;
    padding: 0;
    font-size: x-small;
    height: 1.5rem;
}
.other-payment-options {
    border: none;
    padding-left: 1rem;
    padding-right: 1rem;
}
.paymentOverflow {
    overflow-y: auto;
    width: 100%;
}
/* Hide the browser's default radio button */
  .collapseRadio {
    display: none;
  }
  .price-view-details-conatiner {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .price-view-details-conatiner p {
    margin: 0;
    padding: 0;
    font-weight: bold;
    color: #222222;
  }

  .price-view-details-conatiner .view-details {
    font-size: 8px;
    text-decoration: underline;
    color: #117a7a;
  }
/* imported for paymentOptions */
  .headingregular1.offer01 img{margin-right:5px;margin-top: -6px;}
  .headingregular1.offer01{
    align-items: center;}
  .tandc {
    background-color: #fff;
    border: 1px solid rgba(0,0,0,.125);
    padding: 3px;
  }
  .headingregular1 {
    margin: 8px 0 !important;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
   .CartsetQty {
      float: right;
   }
  .offer-accordian {
    background-color: #ed2e30;
    color: #ffffff;
    font-weight: 100;
    font-size: 0.9em;
    padding: 0 1% 0 1%;
    margin: 0 0 0 2%;
    vertical-align: middle;
  }
  .offer-container {
    background: #fff;
    margin: 3.5% 0 1% 0;
    padding: 10px 12px;
    border: 1px solid #eaeaec;
    border-left: 3px solid #117a7a;
    border-radius: 4px;
    font-size: 14px;
    max-width: 100%;
  }
  .offer-tile {
    color: #117a7a;
    font-weight: 100;
    font-size: 1.2em;
    padding-bottom: 2px;
  }
  .offer-message {
    padding-left: 15px;
    text-indent: -15px;
    list-style: none;
    white-space: normal;
    padding-bottom: 2px;
  }
  .offer-message:before {
    content: "\2022";
    color: rgba(0,0,0,0.6);
    font-size: 1.3em;
    font-weight: bold;
    display: inline-block;
    margin-left: 1em;
  }
  .CartsetQty {
    float: right;
  }

  .paymentoptions .form-check {
    padding: 0;
  }

  .customradio label {
    margin-bottom: 0;
    padding-top: 2px;
    line-height: 1;
  }

  .customradio {
    padding: 5px 0;
  }

  .paymentoptions .customradio [type="radio"] {
    width: 100%;
    height: 100%;
    top: 0;
    margin-right: 0;
    cursor: pointer;

  }

  .cod-error {
    color: #a7a9ac;
    font-weight: 700;
    opacity: 1;
  }

  .form-control {
    border: 1px solid rgba(0, 0, 0, 0.40);
  }

  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #58595b;
  }

  .accordiontabs .card:last-child {
    border-bottom: 1px rgba(0,0,0,0.125) solid;
  }
  .card {
    border: none !important;
  }
  .card.cod {
    border-left: none;
    border-right: none;
  }

  .card.tss-money {
    cursor: pointer;
    margin-bottom: 10px;
  }

  .card-header {
    transition: 0.3s;
    display: table;
    width: 100%;
    cursor: pointer;
  }

  .card.error-cod {
    text-align: center;
    border: none;
  }

  .card.error-cod .card-header {
    padding: 10px;
    display: inline-block;
    margin: 0 auto;
    width: unset;
    padding: 5px 20px;
  }
  .card.error-cod .payment-check {    
    float: left;
    margin-right: 10px;
  }

  .customradio {
    display: table-cell;
    vertical-align: middle;
  }

  .customradio [type="radio"]:not(:checked) + label:before, .customradio [type="radio"]:checked + label:before,
  .customradio [type="radio"]:checked + label:after {
    display: none;
  }

  .customradio [type="radio"]:not(:checked) + label, .customradio [type="radio"]:checked + label {
    padding: 0;
  }

  .center-align {
    display: flex;
    align-items: center;
  }

  .width {
    width: 100%;
  }

  .cartboxlist {
    margin-bottom: 20px;
  }

  .item-count {
    margin: 15px 0 5px;
  }

  .banks {
    height: 80px;
  }

  .collapsepadding {
    padding: 0;
  }

  .cusTabs.accordiontabs h5 a {
    display: inherit;
  }

  .cusTabs .card-header, .cusTabs .card-block {
    padding: 5px 15px;
    min-height: 46px;
  }

  .cusTabs .card-block {
    padding: 0;
    margin: 10px 0;
  }

  hr {
    margin: 0;
  }

  .cartprice {
    padding: 0;
  }

  .offprice {
    float: right;
  }

  .cartTmb.voucher {
    min-height: 1px;
  }

  .cartTmb.voucher img {
    width: 100%;
  }

  .payment-check {
    width: 20px;
    height: 20px;
    background: #fff;
    float: right;
    border-radius: 50%;
    transform: rotate(45deg);
    border: 1px solid #ccc;
    margin-top: 4px;
  }
  .active-tab .payment-check:before,
  .active-tab .payment-check:after {
    content: "";
    position: absolute;
    background-color: #fff;
  }
  .active-tab .payment-check:before{
    width: 2px;
    height: 12px;
    left: 10px;
    top: 2px;
  }

  .active-tab .payment-check:after{
    width: 6px;
    height: 2px;
    left: 5px;
    top: 12px;
  }

  .active-tab .payment-check {
    background: #117a7a;
    margin-top: 4px;
  }

  .card .fa-angle-down {
    font-size: 24px;
    float: right;
    transition: all 0.4s ease;
    color: #282c3f;
  }

  .card .collapsepadding[aria-expanded="true"] .fa-angle-down {
    transform: rotateZ(180deg);
  }

  .card .collapsepadding[aria-expanded="true"],
  .card .collapsepadding:hover {
    color: #282c3f;
  }

  #collapseFour {
    display: none;
  }
  .cusTabs .card-header {
    border-radius: 0;
    background: #fff;
  }

  .gv-detail {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .gv-title {
    margin-right: 10px;
  }

  .paymentErrorMsg {
    background: #FEFFE0;
    border: 1px solid #c8895f;
    color: #c77e77;
    border-radius: 4px;
    display: block;
    width: 100%;
    padding: 10px;
  }

  .vertical-align {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .cartTmb.voucher,
  .exclusive-preview-card .cartTmb {
    min-height: 1px;
  }

  .exclusive-preview-card .info {
    bottom: 0;
  }

  .cartTmb.voucher img {
    width: 100%;
  }

  .exclusive-link {
    color: #000;
    margin: 0 5px;
    text-decoration: underline;
  }

  .go-back {
    color: #3498db;
    cursor: pointer;
  }

  .go-back:hover {
    text-decoration: underline;
  }

  .nameText {
  font-weight: bold;
  }

  .pay-recommend {
    color: #58595b;
    text-transform: none;
  }

  .tss-money-icon {
    height: 25px;
    width: 25px;
    cursor: pointer;
    margin-bottom: 6px;
    margin-right: 10px;
  }
  .price-view-details-conatiner {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .price-view-details-conatiner p {
    margin: 0;
    padding: 0;
    font-weight: bold;
    color: #222222;
  }
  .image-wrapper {
    border:0;
    border-radius: 12%;
    padding:0px;
    margin: 0;
    width: 40px;
    height:25px;
    box-shadow: 0 0 5px #d9caca;           
    overflow: hidden;
  }
  a.disabled {
    pointer-events: none;
    cursor: default;
  }

  @media screen and (max-width: 420px) {
    .offer-accordian {
      background-color: #ed2e30;
      color: #ffffff;
      font-weight: 100;
      font-size: 0.9em;
      padding: 0 2% 0 2%;
      vertical-align: middle;
    }
    .gv-title {
      display: block;
    }

    .colon {
      display: none;
    }
    .offer-container {
      background: #fff;
      margin: 3.5% 0 1% 0;
      padding: 10px 12px;
      border: 1px solid #eaeaec;
      border-left: 3px solid #117a7a;
      border-radius: 4px;
      font-size: 14px;
      max-width: 100%;
    }
    .offer-tile {
      color: #117a7a;
      font-weight: 100;
      font-size: 0.9em;
      padding-bottom: 2px;
    }
    .offer-message {
      padding-left: 15px;
      text-indent: -15px;
      list-style: none;
      font-size: 0.8em;
      white-space: normal;
      padding-bottom: 2px;
    }
    .offer-message:before {
      content: "\2022";
      color: rgba(0,0,0,0.5);
      font-size: 1.2em;
      font-weight: bold;
      display: inline-block;
      margin-left: 1em;
    }
    .tandc {
      padding: 10px;
      font-size: 12px;
    }

  }

  @media screen and (max-width: 768px) {
    .banks {
      height: 50px;
    }
    .tss-money-icon {
      margin-right: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// buyNowMobile.vue?174b846e